<div class="container-fluid contentHeight">
    <div>
        <mat-vertical-stepper id="cartStepper" #stepper class="background-panier" [linear]="true" *ngIf="products && products.length > 0">
            <mat-step>
                <ng-template matStepLabel>{{'shoppingcart.panier' |translate}}</ng-template>
                <div class="basket" *ngIf="products.length > 0">
                    <div class="background-panier col-lg-12 col-md-12 offset-md-0 mt-2 col-sm-12 products">
                        <table class="table table-hover">
                            <caption></caption>
                            <thead>
                                <tr style="font-weight:bold;">
                                    <th scope="col" [translate]="'shoppingcart.designation'" class="respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.prix'" class="text-center respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.quantite'" class="respTh"></th>
                                    <th scope="col" *ngIf="hadLicence || hadBackupAndStats || hadLicenceExtendedWarranty" [translate]="'activlist.balance'" class="text-center respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.prixht'" class="text-center respTh"></th>
                                    <th scope="col" [translate]="'scaleform.effacer'" class="text-center respTh"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let product of products">
                                    <td class="respTdProduct respTd">
                                        <span class="font-weight-bold descTd">{{'shoppingcart.designation'|translate}}{{'stats.common.colon'|translate}}</span>
                                        <div [ngSwitch]="langue">
                                            <div *ngSwitchCase="'fr'">
                                                {{product.designation.fr}}
                                            </div>
                                            <div *ngSwitchCase="'en'">
                                                {{product.designation.en}}
                                            </div>
                                            <div *ngSwitchCase="'de'">
                                                {{product.designation.de}}
                                            </div>
                                            <div *ngSwitchCase="'es'">
                                                {{product.designation.es}}
                                            </div>
                                            <div *ngSwitchCase="'it'">
                                                {{product.designation.it}}
                                            </div>
                                            <div *ngSwitchCase="'nl'">
                                                {{product.designation.nl}}
                                            </div>
                                            <div *ngSwitchCase="'ro'">
                                                {{product.designation.ro}}
                                            </div>
                                            <div *ngSwitchCase="'pt'">
                                                {{product.designation.pt}}
                                            </div>
                                            <div *ngSwitchCase="'pl'">
                                                {{product.designation.pl}}
                                            </div>
                                            <div *ngSwitchCase="'tr'">
                                                {{product.designation.tr}}
                                            </div>
                                            <div *ngSwitchDefault>
                                                {{product.designation.fr}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center respTd "> <span class="font-weight-bold descTd">{{'shoppingcart.prix'|translate}}{{'stats.common.colon'|translate}}</span>{{product.amount | number : '1.2-2'}} €</td>
                                    <td class="respTd ">
                                        <span class="font-weight-bold descTd">{{'shoppingcart.quantite'|translate}}{{'stats.common.colon'|translate}}</span>
                                        <input *ngIf="product.qtyMax!=0 && product.product != 'Abonnement Backup & Statistiques'" [(ngModel)]="product.qty" class="respTdQty" id="number" type="number" (click)="changeQty(product)" (keypress)="quantityKeyUp($event,product)" (keyup)="limitQuantity(product)" min="1" [(max)]="product.qtyMax">
                                        <input *ngIf="product.qtyMax==0 && product.product != 'Abonnement Backup & Statistiques'" [(ngModel)]="product.qty" class="respTdQty anyQtyMax" id="number" type="number" (click)="changeQty(product)" (keypress)="quantityKeyUp($event,product)" (keyup)="limitQuantity(product)" min="1">
                                        <span *ngIf="product.product == 'Abonnement Backup & Statistiques'">{{product.qty}}</span>
                                        <span *ngIf="product.type=='licence'" [translate]="'shoppingcart.annees'"></span>
                                    </td>
                                    <td *ngIf="hadLicence || hadBackupAndStats || hadLicenceExtendedWarranty" class="text-center respScale respTd">
                                        <span class="font-weight-bold descTd">{{'activlist.balance'|translate}}{{'stats.common.colon'|translate}}</span>{{ product.scale }}
                                    </td>
                                    <td class="text-center respTd">
                                        <span class="font-weight-bold descTd">{{'shoppingcart.prixht'|translate}}{{'stats.common.colon'|translate}}</span>{{ product.tPrice | number : '1.2-2'}} €
                                    </td>
                                    <td class="text-center respTd" (click)="removeProduct(product.product)">
                                        <i aria-hidden="true" class="fas fa-trash-alt text-danger"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="text-right">
                    <button mat-button matStepperNext class="btn btn-secondary "> <span [translate]="'scaleform.suivant'"></span> </button>
                </div>
            </mat-step>
            <mat-step [stepControl]="AddressForm" *ngIf="showAddress">
                <ng-template matStepLabel>{{'scaleform.adresse' |translate}}</ng-template>
                <div class="basket" *ngIf="products.length > 0">
                    <div class="row background-panier col-lg-12 col-md-12 offset-md-0 mt-2 col-sm-12 confirmAdr">
                        <form class="col-lg-12  col-md-12" [formGroup]="AddressForm">
                            <div class="col-lg-6 col-md-10">
                                <h5 class="substitle" [translate]="'scaleform.adressefacturation'"></h5>
                                <hr>
                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="socialReasonFact" required>
                                    <!-- <mat-error>Saisissez le raison sociale de la société </mat-error> -->
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="addressFact" required>
                                    <!-- <mat-error>Saisissez l'adresse de la société</mat-error> -->
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="postalCodeFact" required (keypress)="changePostalCode()">
                                    <!-- <mat-error>Saisissez le code postal de la société </mat-error> -->
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="cityFact" required>
                                    <!-- <mat-error>Saisissez la ville de la société </mat-error> -->
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                    <mat-select formControlName="countryFFact" required (selectionChange)="updateCountry()">
                                        <mat-option *ngFor="let countryF of countries" value="{{countryF.name}}"> {{countryF.txt|translate}} </mat-option>
                                    </mat-select>
                                    <!-- <mat-error>Saisissez le pays de la société </mat-error> -->
                                </mat-form-field>
                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="siret">
                                    <!-- <mat-error>Saisissez le numéro de Siret la société </mat-error> -->
                                </mat-form-field>

                                <mat-form-field class="col-lg-12 takeErrorSpace" *ngIf="tvaCkeck">
                                    <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="tva" oninput="this.value = this.value.toUpperCase()" (ngModelChange)="checkTvaIntra()" />
                                    <mat-error>{{'shoppingcart.invalidTva'|translate}}</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-6 col-md-10">
                                <h5 class="substitle" [translate]="'shoppingcart.shippingAddress'"> </h5>
                                <hr>
                                <span>
                                    <mat-checkbox formControlName="checked" (click)="copyFacturationData();">
                                        <span [translate]="'shoppingcart.sameShippingAddress'"></span>
                                    </mat-checkbox>
                                </span>
                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="socialReason" required>
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="address" required>
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="postalCode" required (ngModelChange)="changePostalCode()">
                                </mat-form-field>

                                <mat-form-field class="col-lg-12">
                                    <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="city" required>
                                </mat-form-field>

                                <mat-form-field class="col-lg-9">
                                    <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                    <mat-select formControlName="countryF" required (selectionChange)="changeCountryDelivery()">
                                        <mat-option *ngFor="let countryF of countries" value="{{countryF.name}}"> {{countryF.txt|translate}} </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-checkbox formControlName="island" class="col-lg-3" (click)="activateIsland()">
                                    <span [translate]="'shoppingcart.island'"></span>
                                </mat-checkbox>
                            </div>
                            <div class="col-lg-6 col-md-10 offset-lg-3">
                                <h6>{{'shoppingcart.infocomp'|translate}}:</h6>
                                <mat-form-field class="col-12">
                                    <mat-label>{{'scaleform.mail'|translate}}</mat-label>
                                    <input matInput type="text" formControlName="mail" required>
                                    <mat-error>{{'shoppingcart.requiredMail'|translate}}</mat-error>
                                </mat-form-field>
                            </div>
                        </form>
                    </div>
                    <div class="errorAddress">
                        <p class="text-center" *ngIf="AddressForm.get('tva').hasError('pattern')" [translate]="'shoppingcart.invalidTva'"></p>
                        <p class="text-center" *ngIf="AddressForm.get('mail').hasError('required')" [translate]="'shoppingcart.requiredMail'"></p>
                    </div>
                </div>
                <div *ngIf="AddressForm.valid" class="text-right">
                    <button mat-button matStepperNext class="btn btn-secondary "> <span [translate]="'scaleform.suivant'"></span> </button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>{{'shoppingcart.resume'|translate}}</ng-template>
                <div class="basket" *ngIf="products.length > 0">



                    <div *ngIf="!island && !prodManuel" class="background-panier recap col-12 mt-2">


                        <table class="table table-hover">
                            <caption></caption>
                            <thead>
                                <tr style="font-weight:bold;">
                                    <th scope="col" [translate]="'shoppingcart.designation'" class="respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.prix'" class="text-center respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.quantite'" class="respTh"></th>
                                    <th scope="col" *ngIf="hadLicence || hadBackupAndStats || hadLicenceExtendedWarranty" [translate]="'activlist.balance'" class="text-center respTh"></th>
                                    <th scope="col" [translate]="'shoppingcart.prixht'" class="text-center respTh"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let product of products">
                                    <td class="respTdProduct respTd">
                                        <span [translate]="'shoppingcart.designation'" class="font-weight-bold descTd"> </span>
                                        <div [ngSwitch]="langue">
                                            <div *ngSwitchCase="'fr'">
                                                {{product.designation.fr}}
                                            </div>
                                            <div *ngSwitchCase="'en'">
                                                {{product.designation.en}}
                                            </div>
                                            <div *ngSwitchCase="'de'">
                                                {{product.designation.de}}
                                            </div>
                                            <div *ngSwitchCase="'es'">
                                                {{product.designation.es}}
                                            </div>
                                            <div *ngSwitchCase="'it'">
                                                {{product.designation.it}}
                                            </div>
                                            <div *ngSwitchCase="'nl'">
                                                {{product.designation.nl}}
                                            </div>
                                            <div *ngSwitchCase="'ro'">
                                                {{product.designation.ro}}
                                            </div>
                                            <div *ngSwitchCase="'pt'">
                                                {{product.designation.pt}}
                                            </div>
                                            <div *ngSwitchCase="'pl'">
                                                {{product.designation.pl}}
                                            </div>
                                            <div *ngSwitchCase="'tr'">
                                                {{product.designation.tr}}
                                            </div>
                                            <div *ngSwitchDefault>
                                                {{product.designation.fr}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center respTd "> <span [translate]="'shoppingcart.prix'" class="font-weight-bold descTd"> </span>  {{product.amount | number : '1.2-2'}} €</td>
                                    <td class="respTd ">
                                        <span [translate]="'shoppingcart.quantite'" class="font-weight-bold descTd">    </span>
                                        {{product.qty}}
                                        <span *ngIf="product.type=='licence'" [translate]="'shoppingcart.annees'"></span>
                                    </td>
                                    <td *ngIf="hadLicence ||hadBackupAndStats || hadLicenceExtendedWarranty" class="text-center respScale respTd">
                                        <span [translate]="'activlist.balance'" class="font-weight-bold descTd"> </span>
                                        {{ product.scale }}
                                    </td>
                                    <td class="text-center respTd">
                                        <span [translate]="'shoppingcart.prixht'" class="font-weight-bold descTd"> </span>
                                        {{ product.tPrice | number : '1.2-2'}} €
                                    </td>
                                </tr>
                            </tbody>
                        </table>



                        <div class="tarifglob">
                            <div class="tarif">
                                <!-- Frais de Livraison -->
                                <div class="lib">{{'shoppingcart.shippingFees'|translate}}</div>
                                <div class="price">{{totalfraisLiv | number : '1.2-2'}} €</div>
                            </div>
                            <div class="tarif">
                                <!-- Prix HT -->
                                <div class="lib" [translate]="'shoppingcart.prixht'"></div>
                                <div class="price">{{orderAmount | number : '1.2-2'}} €</div>
                            </div>
                            <div class="part"></div>
                            <div class="tarif">
                                <!-- Prix HT Total-->
                                <div class="lib" [translate]="'shoppingcart.totalHt'"></div>
                                <div class="price">{{orderAmountFL | number : '1.2-2'}} €</div>
                            </div>
                            <div class="tarif">
                                <!-- TVA -->
                                <div class="lib">{{'shoppingcart.tva'|translate}} : {{tauxTva}}%  </div>
                                <div class="price">{{tva | number : '1.2-2'}} €</div>
                            </div>
                            <div class="part"></div>
                            <div class="tarif">
                                <!-- Total -->
                                <div class="lib" [translate]="'shoppingcart.total'"></div>
                                <div class="price">{{orderAmountTTC | number : '1.2-2'}}  € <span *ngIf="tauxTva != 0" [translate]="'shoppingcart.ttc'"></span> </div>
                            </div>
                        </div>

                        <div class="part"></div><br />
                        <div>
                            <div class=" payment">
                                <h5>{{'shoppingcart.modePaiement'|translate}}</h5>
                                <!--<div class="part"></div>-->
                                <br />
                                <mat-radio-group class="row paymentMode" aria-label="Select an option" [(ngModel)]="selectPayment">
                                    <mat-radio-button class="col-12" style="margin-left:16px;" [value]="1">
                                        <span [translate]="'shoppingcart.cb'"> </span>
                                    </mat-radio-button>
                                    <mat-radio-button class="col-12" [value]="2">
                                        <span [translate]="'shoppingcart.virement'"></span>
                                    </mat-radio-button>
                                    <mat-radio-button class="col-12" *ngIf="isFrench" [value]="3">
                                        <span [translate]="'shoppingcart.cheque'"></span>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div class="paydiv">
                                <mat-checkbox class="check" labelPosition="after" required [(ngModel)]="acceptCgs" (click)="hideError()">
                                    <span (click)="cgsModal()" class="cgs" [translate]="'shoppingcart.cgs'"></span>
                                </mat-checkbox>
                                <button class="btn btn-primary" type="button" name="payer" (click)="selectPaymentModal()"> <span [translate]="'shoppingcart.payer'"></span></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="island || prodManuel" class="background-panier devis col-12 mt-2">
                        <div class="tarifglob">
                            <div class="tarif">
                                <!-- Frais de Livraison -->
                                <div class="lib">{{'shoppingcart.shippingFees'|translate}}</div>
                                <div class="price">{{'shoppingcart.shippingFeesUneterminated' | translate}}</div>
                            </div>
                            <div class="tarif">
                                <!-- Prix HT -->
                                <div class="lib" [translate]="'shoppingcart.prixht'"></div>
                                <div class="price">{{orderAmount | number : '1.2-2'}} €</div>
                            </div>
                            <div class="part"></div>
                            <div class="tarif">
                                <!-- Prix HT Total-->
                                <div class="lib" [translate]="'shoppingcart.totalHt'"></div>
                                <div class="price">{{orderAmountFL | number : '1.2-2'}} €</div>
                            </div>
                            <div class="tarif">
                                <!-- TVA -->
                                <div class="lib">{{'shoppingcart.tva'|translate}} : {{tauxTva}}%  </div>
                                <div class="price">{{tva | number : '1.2-2'}} €</div>
                            </div>
                            <div class="part"></div>
                            <div class="tarif">
                                <!-- Total -->
                                <div class="lib" [translate]="'shoppingcart.totalExcludingShippingfees'"></div>
                                <div class="price">{{orderAmountTTC | number : '1.2-2'}}  € <span *ngIf="tauxTva != 0" [translate]="'shoppingcart.ttc'"></span> </div>
                            </div>
                        </div>
                        <div class="part"></div><br />
                        <div class="paydivIsland">
                            <span [translate]="'shoppingcart.quoteInfo'"></span>
                            <div>
                                <mat-checkbox class="check" labelPosition="after" required [(ngModel)]="acceptCgs" (click)="hideError()">
                                    <span (click)="cgsModal()" class="cgs" [translate]="'shoppingcart.cgs'"></span>
                                </mat-checkbox>
                                <button class="btn btn-primary quotebtn" type="button" name="quote" (click)="pay(0)"> <span [translate]="'shoppingcart.sendQuote'"></span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>

        </mat-vertical-stepper>
    </div>
</div>

<div id="errorcgs" class="basket col-lg-11 col-md-12 offset-md-0 mt-2 col-sm-12 text-center background-panier">
    <p class="errorcgs text-center" [translate]="'shoppingcart.errorCgs'"></p>
</div>

<div id="ModalCheque" class="modal">
    <div class="modal-content backgroundWhiteRound">
        <div class="row">
            <div class="col-12">
                <span class="rightFlex close pointer" (click)="closeChequePayment();">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1 class="text-center" [translate]="'shoppingcart.infocheque'"></h1>
            </div>
        </div>
        <div>
            <div class="ribBox mb-2 col-lg-8 col-md-10 col-sm-12 mx-auto">
                <ul>
                    <li>
                        <div *ngIf="bankInfoLacour.address != null">
                            <span class="font-weight-bold" [translate]="'shoppingcart.adresse'"></span> :
                            <div *ngFor="let a of bankInfoLacour.address.split('|')">{{a}}</div>
                        </div>
                    </li>
                    <li>
                        <span class="font-weight-bold" [translate]="'shoppingcart.info'"></span> : {{orderNumber}}
                    </li>
                    <li>
                        <span class="font-weight-bold" [translate]="'shoppingcart.ordre'"></span> : {{bankInfoLacour.order}}
                    </li>
                    <li>
                        <span class="font-weight-bold" [translate]="'shoppingcart.montantregler'"></span> : {{orderAmountTTC | number : '1.2-2'}} € <span [translate]="'shoppingcart.ttc'"></span>
                    </li>
                </ul>
            </div>
            <div class="center noPrint">
                <button class="btnReglement" type="button" name="Valider" value="Valider" (click)="pay(2)">Valider</button>
            </div>
        </div>
    </div>
</div>

<div id="ModalEmptyCart" class="modal" *ngIf="products && products.length == 0">
    <div class="modal-content backgroundWhiteRound">
        <div class="row">
            <div class="col-12">
                <span class="rightFlex close pointer" (click)="closeEmptyCart();">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
            </div>
        </div>
        <div class="emptyCart">
            <h1 class="text-center" [translate]="'shoppingcart.empty'"></h1>
            <i aria-hidden="true" class="fal fa-shopping-cart iconBackground"></i>
        </div>
    </div>
</div>

<div id="ModalVirement" class="modal">
    <div class="modal-content backgroundWhiteRound">
        <div class="row">
            <div class="col-12">
                <span class="text-right close pointer" (click)="closeVirementPayment();">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1 class="text-center" [translate]="'shoppingcart.vir'"></h1>
            </div>
        </div>
        <div>
            <div class="col-lg-8 col-md-10 col-sm-12 mx-auto ">
                <div *ngIf="hadLicence || hadBackupAndStats || hadLicenceExtendedWarranty"><span class="font-weight-bold" [translate]="'shoppingcart.labelvir'"></span> : IxellConnect/{{cu}}/{{scale}}/{{activationId}}</div>
                <div *ngIf="hadLicence == false && !hadBackupAndStats && !hadLicenceExtendedWarranty"><span class="font-weight-bold" [translate]="'shoppingcart.labelvir'"></span> : {{orderNumber}}</div>
            </div>
            <div class="row">
                <div class="col-lg-8 col-md-10 col-sm-12 mx-auto bg-light">
                    <!-- <h3 class="text-danger text-center" [translate]="'shoppingcart.rib'">  </h3> -->
                    <span [translate]="'shoppingcart.idinternational'"> </span>
                    <div class="ribBox mb-2">
                        <div class="col-12" *ngIf="bankInfoLacour.iban!=null">
                            <span class="font-weight-bold " [translate]="'shoppingcart.iban'">  </span>
                            : {{bankInfoLacour.iban}}
                        </div>
                        <div class="col-12" *ngIf="bankInfoLacour.bic!=null">
                            <span class="font-weight-bold" [translate]="'shoppingcart.bic'">  </span>
                            : {{bankInfoLacour.bic}}
                        </div>
                    </div>
                    <span [translate]="'shoppingcart.titulaire'"> </span>
                    <span class="font-weight-bold"> : {{bankInfoLacour.owner}} </span>
                    <br /><br />
                    <span class="font-weight-bold" [translate]="'shoppingcart.montantregler'"></span>
                    <span> : {{orderAmountTTC | number : '1.2-2'}}  € </span> <span [translate]="'shoppingcart.ttc'"></span>
                </div>
            </div>
            <div class="center noPrint">
                <button class="btnReglement" type="button" name="Valider" value="Valider" (click)="pay(2)">
                    <span [translate]="'shoppingcart.validate'|translate"></span>
                </button>
            </div>
        </div>
    </div>
</div>

<!--
<div id="ModalCGS" class="modal modalcgs">
    <div class="modal-contentcgs cgscontent bg-light backgroundWhiteRound">
        <div class="col-12 closeIcon">
            <h1 class="text-right pointer close" (click)="closeCgs()"> <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </h1>
        </div>
        <app-cgs (langChange)="cgsLangChange()"></app-cgs>
    </div>
</div>
-->

<div id="ModalCGS" class="modal">
    <div class="modal-content cgscontent">
        <div class="flex flex-row justify-content-between">
            <div class="cgs-menu">
                <nav>
                    <button class="text-right pointer goToBtn" (click)="toggleCGSNav()">
                        Aller à <i class="fa-solid fa-caret-down"></i>
                    </button>
                    <div id="cgs-menu-sections" [style.display]="(displayCGSNav ? null : 'none')"></div>
                </nav>
            </div>
            <h1 class="text-right pointer close" (click)="closeCGS()">
                <i aria-hidden="true" class="fal fa-times primaryRed"></i>
            </h1>
        </div>
        <app-cgs class="cgsModalComp" (langChange)="cgsLangChange()">
        </app-cgs>
    </div>
</div>
